export default __webpack_public_path__ + "static/media/form.38f6f458.jpg";